import { AssistantFullMessage, MessageControlProps } from "../../types";
import { CandidateSearchResults } from "./CandidateSearchResults";
import { CallToActionCard } from "./CallToActionCard";

// PERRY_DATA_CARDS maps the AssistantFullMessage.type to the component that renders it's data
// @ts-expect-error - it's fine
export default {
  candidate_search: CandidateSearchResults,
  call_to_action: CallToActionCard,
} as Record<string, React.ComponentType<AssistantFullMessage & MessageControlProps>>;
